import { useEffect, useState } from "react";
import { programaDeReunion, rpc } from "../../services/datos";
import { antetitulo } from "../../shared/estilos";
import Esqueleto from "../../shared/components/Esqueleto";

const COLOR_ESTADO = { confirmado: "text-green-300", rechazado: "text-red-300", pendiente: "text-yellow-300" };
const TEXTO_ESTADO = { confirmado: "Confirmó", rechazado: "No puede", pendiente: "Sin responder" };

// Lo que un servidor necesita saber de su reunión: con quién sirve y el programa.
function DetalleReunion({ servicioId }) {
  const [equipo, setEquipo] = useState(null);
  const [programa, setPrograma] = useState(undefined);
  const [error, setError] = useState("");

  useEffect(() => {
    rpc("equipo_reunion", { p_servicio: Number(servicioId) }).then(setEquipo).catch((e) => setError(e.message));
    programaDeReunion(servicioId).then(setPrograma).catch(() => setPrograma(null));
  }, [servicioId]);

  if (error) return <p className="mt-4 text-sm text-red-300">{error}</p>;
  if (!equipo) return <Esqueleto tipo="texto" className="mt-4" texto="Cargando la reunión…" />;

  const porArea = equipo.reduce((grupos, persona) => {
    (grupos[persona.area] = grupos[persona.area] || []).push(persona);
    return grupos;
  }, {});
  const canciones = [...(programa?.canciones_programacion || [])].sort((a, b) => a.orden - b.orden);

  return (
    <div className="mt-5 grid gap-4 border-t border-gray-800 pt-5 lg:grid-cols-2">
      <section>
        <h4 className="titulo-panel">Equipo de la reunión</h4>
        <div className="mt-3 space-y-3">
          {Object.entries(porArea).map(([area, personas]) => (
            <div key={area} className="panel-interior p-3">
              <p className="text-white font-bold text-sm">{area}</p>
              <ul className="mt-2 space-y-1">
                {personas.map((p) => (
                  <li key={p.turno_id} className="flex justify-between gap-3 text-sm">
                    <span className={p.soy_yo ? "font-semibold text-white" : "text-gray-300"}>
                      {p.nombres} {p.apellidos}{p.soy_yo ? " (tú)" : ""}{p.rol ? ` · ${p.rol}` : ""}
                    </span>
                    <span className={`shrink-0 text-xs ${COLOR_ESTADO[p.estado]}`}>{TEXTO_ESTADO[p.estado]}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h4 className="titulo-panel">Programa</h4>
        {!programa ? (
          <p className="mt-3 text-sm text-gray-400">El programa de esta reunión aún no está listo.</p>
        ) : (
          <div className="panel-interior mt-3 p-4">
            <p className="text-white font-semibold">{programa.titulo_predica || "Prédica sin título"}</p>
            {programa.predicador && <p className="mt-1 text-sm text-gray-400">Predica: {programa.predicador}</p>}
            {programa.version_biblica && <p className="text-sm text-gray-400">Versión: {programa.version_biblica}</p>}
            {programa.versiculos && <p className="mt-3 whitespace-pre-line text-sm text-gray-200">{programa.versiculos}</p>}
            {programa.notas && <p className="mt-3 whitespace-pre-line text-sm text-gray-400">Notas: {programa.notas}</p>}
            {canciones.length > 0 && (
              <>
                <p className={`${antetitulo} mt-5`}>Canciones</p>
                <ol className="mt-2 space-y-1 text-sm">
                  {canciones.map((c) => (
                    <li key={c.id} className="text-gray-200">
                      {c.orden}. {c.cancion}{c.artista ? ` · ${c.artista}` : ""}
                      {c.enlace && (
                        <a href={c.enlace} target="_blank" rel="noreferrer" className="ml-2 text-xs text-gray-400 underline hover:text-white">
                          Escuchar
                        </a>
                      )}
                    </li>
                  ))}
                </ol>
              </>
            )}
          </div>
        )}
      </section>
    </div>
  );
}

export default DetalleReunion;
